/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaQDEntryResponse from './AqaQDEntryResponse';

/**
 * The AvaQdDirectoryResponse model module.
 * @module model/AvaQdDirectoryResponse
 * @version v0
 */
export default class AvaQdDirectoryResponse {
  /**
   * Constructs a new <code>AvaQdDirectoryResponse</code>.
   * @alias module:model/AvaQdDirectoryResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AvaQdDirectoryResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AvaQdDirectoryResponse} obj Optional instance to populate.
   * @return {module:model/AvaQdDirectoryResponse} The populated <code>AvaQdDirectoryResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AvaQdDirectoryResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('privateQualityDefinitions'))
        obj.privateQualityDefinitions = ApiClient.convertToType(data['privateQualityDefinitions'], [AqaQDEntryResponse]);
      if (data.hasOwnProperty('protectedQualityDefinitions'))
        obj.protectedQualityDefinitions = ApiClient.convertToType(data['protectedQualityDefinitions'], [AqaQDEntryResponse]);
      if (data.hasOwnProperty('publicQualityDefinitions'))
        obj.publicQualityDefinitions = ApiClient.convertToType(data['publicQualityDefinitions'], [AqaQDEntryResponse]);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AvaQdDirectoryResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AvaQdDirectoryResponse.prototype.message = undefined;

/**
 * @member {Array.<module:model/AqaQDEntryResponse>} privateQualityDefinitions
 */
AvaQdDirectoryResponse.prototype.privateQualityDefinitions = undefined;

/**
 * @member {Array.<module:model/AqaQDEntryResponse>} protectedQualityDefinitions
 */
AvaQdDirectoryResponse.prototype.protectedQualityDefinitions = undefined;

/**
 * @member {Array.<module:model/AqaQDEntryResponse>} publicQualityDefinitions
 */
AvaQdDirectoryResponse.prototype.publicQualityDefinitions = undefined;

/**
 * @member {Boolean} successful
 */
AvaQdDirectoryResponse.prototype.successful = undefined;

